<template>
  <a
    v-if="showCancelFlg"
    href="javascript:void(0);"
    size="small"
    :class="className"
    :loading="loading"
    type="link"
    @click="handleOk"
  >
    撤销
  </a>
</template>

<script>
import { defineComponent, computed } from "vue";
import { ApprovalFlowService } from "../approval-flow.service";
import { message } from "ant-design-vue";
import { useStore } from "@/store";
export default defineComponent({
  name: "submit-approval-btn",
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    flg: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    access: {
      type: String,
    },
    className: {
      type: String,
    },
  },
  emits: ["refresh", "update:loading"],
  setup(props, { emit }) {
    const store = useStore();
    const { run } = ApprovalFlowService.useCancelApi();
    const handleOk = async () => {
      try {
        emit("update:loading", true);
        const { bizId, bizType } = props;
        const data = {
          bizId,
          bizType,
        };
        let res = await run(data);
        if (res.respCode !== "0000") {
          // message.error(res.respDesc);
          return;
        }
        message.success(res.respDesc);
        emit("refresh", null);
      } finally {
        emit("update:loading", false);
      }
    };
    const showCancelFlg = computed(() => {
      let t = store.state.user.buttons[props.access || ""];
      return t && props.flg;
    });
    return {
      handleOk,
      showCancelFlg,
    };
  },
});
</script>

<style scoped></style>
